import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import {
  addLeadActivity,
  assignLead,
  convertLead,
  createLead,
  deleteLead,
  getLead,
  getLeadMeta,
  getLeads,
  getMyLeads,
  updateLead,
  updateLeadStatus,
} from "api/leadApi"

export const LEAD_QUERY_KEY = "leads"

export const useLeads = (params = {}, enabled = true) =>
  useQuery({
    queryKey: [LEAD_QUERY_KEY, "list", params],
    queryFn: () => getLeads(params),
    enabled,
    keepPreviousData: true,
  })

export const useMyLeads = (params = {}, enabled = true) =>
  useQuery({
    queryKey: [LEAD_QUERY_KEY, "my", params],
    queryFn: () => getMyLeads(params),
    enabled,
    keepPreviousData: true,
  })

export const useLeadMeta = (enabled = true) =>
  useQuery({
    queryKey: [LEAD_QUERY_KEY, "meta"],
    queryFn: getLeadMeta,
    enabled,
    staleTime: 10 * 60 * 1000,
  })

export const useLead = id =>
  useQuery({
    queryKey: [LEAD_QUERY_KEY, "detail", id],
    queryFn: () => getLead(id),
    enabled: Boolean(id),
  })

const useLeadMutation = mutationFn => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LEAD_QUERY_KEY] })
    },
  })
}

export const useCreateLead = () => useLeadMutation(createLead)
export const useUpdateLead = () => useLeadMutation(updateLead)
export const useUpdateLeadStatus = () => useLeadMutation(updateLeadStatus)
export const useAssignLead = () => useLeadMutation(assignLead)
export const useAddLeadActivity = () => useLeadMutation(addLeadActivity)
export const useConvertLead = () => useLeadMutation(convertLead)
export const useDeleteLead = () => useLeadMutation(deleteLead)
